import React from 'react';
import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Typography,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import CourierLayout from '../CourierLayout';

const SupportAndHelpCenterCourier = () => {
  const history = useHistory();

  const supportItems = [
    {
      title: 'Account & Profile',
      description:
        'Help with account details, vehicle information, and driver/carrier settings.',
    },
    {
      title: 'Loads & Assignments',
      description:
        'Help with available loads, active assignments, bids, and negotiations.',
    },
    {
      title: 'Completion Confirmation',
      description:
        'Help with completion confirmation, photos, signatures, and notes.',
    },
    {
      title: 'Payments & Payouts',
      description:
        'Help with payout timing, payment history, and earnings-related questions.',
    },
  ];

  return (
    <CourierLayout>
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h4"
          sx={{
            fontSize: '2rem',
            fontWeight: 700,
            lineHeight: 1.25,
            color: '#0f172a',
            mb: 1,
            textAlign: 'center',
          }}
        >
          Support Center
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: '#64748b',
            textAlign: 'center',
            fontSize: '0.95rem',
            lineHeight: 1.5,
          }}
        >
          Support resources and assistance for drivers and carriers.
        </Typography>
      </Box>

      <Paper
        elevation={1}
        sx={{
          p: { xs: 2, md: 2.5 },
          borderRadius: 3,
          border: '1px solid rgba(15, 23, 42, 0.08)',
          backgroundColor: '#ffffff',
        }}
      >
        <Grid container spacing={2}>
          {supportItems.map((item) => (
            <Grid item xs={12} md={6} key={item.title}>
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  height: '100%',
                  borderRadius: 3,
                  backgroundColor: '#f8fafc',
                  border: '1px solid #e2e8f0',
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: '#0f172a',
                    fontWeight: 700,
                    mb: 0.75,
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    color: '#64748b',
                    fontSize: '0.95rem',
                    lineHeight: 1.5,
                  }}
                >
                  {item.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              history.push('/courier/emergency-assistance')
            }
            sx={{
              minWidth: 260,
              minHeight: 46,
              textTransform: 'none',
              fontWeight: 700,
              borderRadius: 2,
            }}
          >
            Submit Support Request
          </Button>
        </Box>
      </Paper>
    </CourierLayout>
  );
};

export default SupportAndHelpCenterCourier;